import React from 'react';
import "./prostyle.scss";
import ProCarousel from "./ProCarousel";

import vd_0 from "../imgs55/VT55WGV1-gallery-00-h265-crf30.mp4";
import thumb_0 from "../imgs55/Thumbnail/VT55WGV1-gallery-00.webp";
import img_1 from "../imgs55/VT55WGV1-gallery-01.webp";
import thumb_1 from "../imgs55/Thumbnail/VT55WGV1-gallery-01.webp";
import img_2 from "../imgs55/VT55WGV1-gallery-02.webp";
import thumb_2 from "../imgs55/Thumbnail/VT55WGV1-gallery-02.webp";
import img_3 from "../imgs55/VT55WGV1-gallery-03.webp";
import thumb_3 from "../imgs55/Thumbnail/VT55WGV1-gallery-03.webp";
import img_4 from "../imgs55/VT55WGV1-gallery-04.webp";
import thumb_4 from "../imgs55/Thumbnail/VT55WGV1-gallery-04.webp";
import img_5 from "../imgs55/VT55WGV1-gallery-05.webp";
import thumb_5 from "../imgs55/Thumbnail/VT55WGV1-gallery-05.webp";
import img_6 from "../imgs55/VT55WGV1-gallery-06.webp";
import thumb_6 from "../imgs55/Thumbnail/VT55WGV1-gallery-06.webp";
import img_7 from "../imgs55/VT55WGV1-gallery-07.webp";
import thumb_7 from "../imgs55/Thumbnail/VT55WGV1-gallery-07.webp";
import img_8 from "../imgs55/VT55WGV1-gallery-08.webp";
import thumb_8 from "../imgs55/Thumbnail/VT55WGV1-gallery-08.webp";
import img_9 from "../imgs55/VT55WGV1-gallery-09.webp";
import thumb_9 from "../imgs55/Thumbnail/VT55WGV1-gallery-09.webp";
import img_10 from "../imgs55/VT55WGV1-gallery-10.webp";
import thumb_10 from "../imgs55/Thumbnail/VT55WGV1-gallery-10.webp";
import img_11 from "../imgs55/VT55WGV1-gallery-11.webp";
import thumb_11 from "../imgs55/Thumbnail/VT55WGV1-gallery-11.webp";
import img_12 from "../imgs55/VT55WGV1-gallery-12.webp";
import thumb_12 from "../imgs55/Thumbnail/VT55WGV1-gallery-12.webp";
import img_13 from "../imgs55/VT55WGV1-gallery-13.webp";
import thumb_13 from "../imgs55/Thumbnail/VT55WGV1-gallery-13.webp";
import img_14 from "../imgs55/VT55WGV1-gallery-14.webp";
import thumb_14 from "../imgs55/Thumbnail/VT55WGV1-gallery-14.webp";

class ProVerticalCarousel55 extends React.Component {
    render() {
        const data = [
            {
                video: vd_0,
                thumbnail: thumb_0,
            },
            {
                image: img_1,
                thumbnail: thumb_1,
            },
            {
                image: img_2,
                thumbnail: thumb_2,
            },
            {
                image: img_3,
                thumbnail: thumb_3,
            },
            {
                image: img_4,
                thumbnail: thumb_4,
            },
            {
                image: img_5,
                thumbnail: thumb_5,
            },
            {
                image: img_6,
                thumbnail: thumb_6,
            },
            {
                image: img_7,
                thumbnail: thumb_7,
            },
            {
                image: img_8,
                thumbnail: thumb_8,
            },
            {
                image: img_9,
                thumbnail: thumb_9,
            },
            {
                image: img_10,
                thumbnail: thumb_10,
            },
            {
                image: img_11,
                thumbnail: thumb_11,
            },
            {
                image: img_12,
                thumbnail: thumb_12,
            },
            {
                image: img_13,
                thumbnail: thumb_13,
            },
            {
                image: img_14,
                thumbnail: thumb_14,
            },
        ];

        const slideNumberStyle = {
            fontSize: '20px', fontWeight: 'bold',
        }

        return (
            <div style={{textAlign: "center", width: "100%", display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '60px'}}>
                <ProCarousel
                    data={data}
                    time={3000}
                    width="45vw"
                    height="60vh"
                    radius="10px"
                    slideNumber={false}
                    slideNumberStyle={slideNumberStyle}
                    captionPosition="bottom"
                    automatic={false}
                    dots={false}
                    pauseIconColor="white"
                    pauseIconSize="40px"
                    slideBackgroundColor="darkgrey"
                    slideImageFit="cover"
                    mediaBackgroundColor="white"
                    thumbnails={true}
                    thumbnailWidth="100px"
                    thumbnailHeight={'100px'}
                    style={{
                        textAlign: "center",
                        maxWidth: "100vw",
                        // maxHeight: "500px",
                        // margin: "50px auto",
                        // backgroundColor: 'red'
                        backgroundColor: '#f4f4f4'
                    }}
                />
            </div>
        );
    }
}

export default ProVerticalCarousel55;
